import { Formik } from 'formik'
import React, { useCallback } from 'react'
import validate from 'helpers/contact-form-validation'
import ContactForm from './ContactForm'
import { contact } from 'services/api'

const Form = () => {
  const onSubmit = useCallback(async (values, actions) => {
    actions.setSubmitting(true)
    const resp = await contact(values)

    if (resp.ok) {
      actions.resetForm()
      actions.setStatus({
        submitSuccess: 'Message sent successfully!',
      })
      setTimeout(() => actions.setStatus(null), 5000)
    } else {
      const errorMessage =
        resp.data && resp.data.message
          ? resp.data.message
          : 'An error occurred, Please Try Again'

      actions.resetForm(values)
      actions.setStatus({
        submitError: errorMessage,
      })
    }
    actions.setSubmitting(false)
  }, [])

  return (
    <Formik
      initialValues={{
        reason: '_initial',
        contact: '_initial',
        name: '',
        email: '',
        subject: '',
        message: '',
        attachment: '',
      }}
      onSubmit={onSubmit}
      validate={validate}
      render={ContactForm}
    />
  )
}

export default Form
